<app-search-results-item [item]="item"
                         (onFilter)="onFilter.emit(item)"
                         (onOpen)="onOpen.emit(item)"
                         *ngFor="let item of items$ | async | searchResults:value"></app-search-results-item>
<ng-container *ngIf="!(items$ | async | searchResults:value).length">
  <div class="no-results-container">
    {{ 'reports.no_results' | translate }}
  </div>
</ng-container>
